import apiClient from "./apiClient";
const resource = "/reservations";
const billResource = "/reservation-payments";

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },
  async getReservationCalendar(params = {}) {
    return apiClient.get(`reservation-calendar`, { params });
  },
  async getBill(uuid) {
    return apiClient.get(`${resource}/${uuid}/bill`);
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async payBill(data) {
    return apiClient.post(`${billResource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async addExtraCharge(uuid, data) {
    return apiClient.put(`${resource}/${uuid}/extracharge`, data);
  },
  async update(uuid, data) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async void(uuid) {
    return apiClient.put(`${resource}/${uuid}/void`);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
};
